import { Card, CardHeader } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import logger from "../../../services/logger";
import Form from "../../common/form";
import {
  getFormTitleText,
  getJoiSchema,
  getStateObject,
} from "../../common/formUtils";
import mileageJson from "./mileage.json"

import busService from "../manage-buses/bus.service";
import mileageService from "./mileage.service";

class MileageForm extends Form {
  constructor() {
    super();
    this.formJson = mileageJson;
    this.state = {
      data: getStateObject(this.formJson.groups),
      errors: {},
      dropDowns: {},
    };
    this.schema = getJoiSchema(this.formJson.groups);
  }


  async componentDidMount() {
    this.getBuses();
    // this.getDrivers();
    await this.populateForm();
  }


  async populateForm() {
    const id = this.props.id;
    if (id === "new") return;
    try {
      const { data } = await mileageService.get(id);
      this.mapToViewModel(data);
    } catch (ex) {
      logger.error(ex);
    }
  }

  async getBuses(){
    const {data:buses}=await busService.getAll();
    const dropDowns={...this.state.dropDowns}
    dropDowns.buses=buses;
    this.setState({dropDowns});
    }
  

  doSubmit = async (id) => {
    try {
      if (id === "new") {
        await mileageService.create(this.state.data);
      } else {
        await mileageService.partialUpdate(this.state.data,id);
      }
      this.props.onSave();
    } catch (ex) {
      logger.log(ex);
    }
  };

  render() {
    const { t } = this.props;
    const { dropDowns } = this.state;
    const id = this.props.id;

    const titleText = getFormTitleText(id, this.formJson.alias);

    return (
      <Card>
        <form onSubmit={(event) => this.handleSubmit(event, id)}>
          {/* <CardHeader title={t(titleText)} /> */}
          {this.renderForm(this.formJson, dropDowns)}
          {/* <CardContent>
            <Grid container item sm={12} md={12} direction="row-reverse">
              {this.renderMatButton(t(buttonText))}
              {this.renderMatButton(t("common:Reset"), "reset", "secondary")}
            </Grid>
          </CardContent> */}
        </form>
      </Card>
    );
  }
}

export default withTranslation(["mileage", "common"])(
  MileageForm
);
